import tableCountries from './tableCountries';

export default {
  title: 'Countries',
  attributeName: 'countries',
  getURL: 'countriesPaginate',
  createURL: '',
  updateURL: '',
  removeURL: '',
  idAttribute: 'id',
  itemName: 'name',
  itemId: 'id',
  tableConfig:  tableCountries,
  sessionParams:[],
};
